<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Create Property Map'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/houses.svg'"
            class="title-size" />
          <tidy-text
            [header]="'AR Room Scanner'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Use your device\'s LiDAR scanner to create a detailed 3D floor plan of your property. Walk through each room slowly while pointing your device at walls, floors, and furniture.'" />
        </tidy-row>
      </tidy-card>

      @if (!scanSupport?.supported) {
        <tidy-alert>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/icon/alert-circle-red.svg'"
              class="header-size" />
            <tidy-text
              [body]="scanSupport?.reason || 'AR scanning is not supported on this device.'" />
          </tidy-row>
        </tidy-alert>
      }

      @if (scanSupport?.supported) {
        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'How It Works'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'1. Tap Start Scanning to begin'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'2. Point your device at the room and slowly pan around'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'3. Follow the on-screen instructions'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'4. Tap Done when you have captured the entire floor'" />
          </tidy-row>
        </tidy-card>

        <tidy-card>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [header]="'Tips for Best Results'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'• Ensure good lighting (50+ lux recommended)'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'• Move slowly and steadily'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'• Scan one floor at a time'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'• Keep device 2-3 feet from walls'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'• Best for areas up to 2,000 sq ft'" />
          </tidy-row>
        </tidy-card>

        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }

        <tidy-button
          [text]="isScanning ? 'Scanning...' : 'Start Scanning'"
          [action]="boundStartScan"
          [disabled]="isScanning"
          class="primary" />
      }
    }

    @if (!loaded) {
      <tidy-card>
        <tidy-row>
          <ion-skeleton-text animated style="width: 60%" />
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 100%" />
        </tidy-row>
      </tidy-card>
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
